import CheckSharpIcon from "@mui/icons-material/CheckSharp";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Card, CardContent, IconButton, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";
import { useContext } from "react";
import { ConstantContext } from "components/context/ConstantProvider";
import { Form } from "components/shared/Form";
import { SnackbarContext } from "components/context/SnackbarProvider";
import WithConfirmationButton from "components/ui/atoms/WithConfirmationButton";
import DictionaryField from "components/ui/atoms/formFields/DictionaryField";
import UserField from "components/ui/atoms/formFields/UserField";
import { useValidateCommitteeMeeting } from "models/sourcings/apiSourcing";

const asArray = (obj) => {
  return Array.isArray(obj) ? obj : obj ? [obj] : [];
};

const CommitteeFilterAndSort = ({ state, setState, onClose, refetchList }) => {
  const theme = useTheme();
  const { displayMessage, displayError } = useContext(SnackbarContext);
  const { sourcingStatuses, dealFlows } = useContext(ConstantContext);

  const {
    mutate: mutateValidateSourcingCommittee,
    isLoading: validateSourcingCommitteIsLoading,
  } = useValidateCommitteeMeeting({
    onSucces: () => {
      handleOpenValidateCommittee();
      refetchList && refetchList();
      displayMessage("Committee is validate", <>&#127881;</>, "success");
    },
    onError: () => {
      handleOpenValidateCommittee();
      displayError(error);
    },
  });

  return (
    <Card
      sx={{
        backgroundColor: `${theme.palette.secondary.extralight}`,
        my: 1,
      }}
    >
      <CardContent>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 1,
          }}
        >
          <Typography variant="h6">Committee</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Grid container spacing={1} p={1}>
          <Form
            prepareInitialValues={(object) => ({
              sourcing_owner: asArray(object?.sourcing_owner),
              deal_flow: asArray(object?.deal_flow),
              status: asArray(object?.status),
            })}
            onSubmit={(value) => {
              setState(value);
              return state;
            }}
            values={state}
            autoSubmit
          >
            <Grid size={{ xs: 12, md: 6 }}>
              <UserField name="sourcing_owner" label="Owner" multiple />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <DictionaryField
                optionsDictionary={Object.fromEntries(
                  sourcingStatuses.map((x) => [x.code, x.label]),
                )}
                multiple
                name="status"
                label="Status"
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <DictionaryField
                optionsDictionary={Object.fromEntries(
                  dealFlows.map((x) => [x.id, x.name]),
                )}
                multiple
                name="deal_flow"
                label="Dealflow"
              />
            </Grid>
          </Form>
        </Grid>
        <Grid container spacing={1} p={1}>
          <Grid size={12} textAlign="end">
            <WithConfirmationButton
              disabled={!state?.deal_flow || state.deal_flow.length !== 1}
              confirmationMessage="Confirm committee"
              variant="outlined"
              endIcon={<CheckSharpIcon sx={{ scale: "0.8" }} />}
              onClick={() =>
                mutateValidateSourcingCommittee(state.deal_flow[0])
              }
              loading={validateSourcingCommitteIsLoading}
            >
              Validate committee
            </WithConfirmationButton>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default CommitteeFilterAndSort;
